import LoadableContainer from '~/components/molecule/LoadableContainer';

const LoadableEditor = LoadableContainer({
  loader: () => import('./components/ClientSideCodeEditor'),
});

export default LoadableEditor;
